import React from "react"
import Icon from "../../../components/Icon/Icon"

interface AssignmentsQueueHeaderProps {
	isCollapsed: boolean
	onToggle: () => void
}

export function AssignmentsQueueHeader({isCollapsed, onToggle}: AssignmentsQueueHeaderProps) {
	if (isCollapsed) {
		return (
			<>
				<div className="collapsed-queue-header">
					<button type="button" className="assignments-queue-toggle-btn" onClick={onToggle} title="Expand queue">
						<Icon icon="interface-arrows-button-right--interface-essential" size={13} />
					</button>
				</div>
				<div className="collapsed-queue-divider" />
			</>
		)
	}

	return (
		<div className="expanded-queue-header">
			<span className="expanded-queue-header-label">Group by (Item Status)</span>
			<button type="button" className="assignments-queue-toggle-btn" onClick={onToggle} title="Collapse queue">
				<Icon icon="interface-arrows-button-left--interface-essential" size={13} />
			</button>
		</div>
	)
}
